var map = {
	"./404.svg": "a14a",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./conversion.svg": "2134",
	"./dashboard.svg": "f782",
	"./documentation.svg": "90fb",
	"./drag-gripper.svg": "a6e7",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./education.svg": "ad1c",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./fullscreen.svg": "9921",
	"./gear.svg": "16ec",
	"./guide.svg": "6683",
	"./icon.svg": "9d91",
	"./icon_calendar.svg": "dd20",
	"./icon_employees.svg": "b5f9",
	"./icon_forbidden.svg": "2c11",
	"./icon_invisible.svg": "c721",
	"./icon_password.svg": "96b5",
	"./icon_save.svg": "2655",
	"./icon_user.svg": "70de",
	"./icon_visual.svg": "ef08",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./logo.svg": "bb69",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./nested.svg": "dcf8",
	"./new-outline.svg": "26a2",
	"./notice.svg": "fc99",
	"./password.svg": "2a3d",
	"./paste.svg": "12fc",
	"./pdf.svg": "f9a1",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./permission.svg": "3979",
	"./plus.svg": "2ece",
	"./qq.svg": "1430",
	"./save.svg": "0e55",
	"./search.svg": "8e8d",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./skill.svg": "096e",
	"./star.svg": "708a",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./theme.svg": "e534",
	"./tree-table.svg": "e7c8",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./wechat.svg": "80da",
	"./zhangbu.svg": "c1ab",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";